import { FC } from "react";
import styles from "./styles.module.scss";
import NotaName from "assets/icons/some-documents.svg?react";
import { Props } from "./typings";

const SelectedElementsPanel: FC<Props> = ({ count }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <NotaName className={styles.img} />
        <div className={styles.text}>
          <b>Zaznaczono {count}</b> dodaj kolejne lub odznacz
        </div>
      </div>
    </div>
  );
};

{
  /* <div className={styles.empty}>
         <LogoIcon className={styles.logo} /> 
       </div> */
}
export default SelectedElementsPanel;
